import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useViews } from '../../hooks/use-views';

import { SelectAddressView } from './Views/Addresses/SelectAddressView/SelectAddressView';
import {
  ADD_DELIVERY_ADDRESS,
  ADD_PAYMENT,
  SELECT_DELIVERY_ADDRESS,
  SELECT_PAYMENT,
  CONFIRM_PAYMENT,
  CONFIRM_LEAVE,
  EDIT_ADDRESS,
  EDIT_PAYMENT,
} from '../../models/views';
import { SelectPaymentView } from './Views/Payments/SelectPaymentView/SelectPaymentView';
import { InstantCheckoutAddPayment } from './Views/Payments/AddPaymentView/InstantCheckoutAddPayment';
import { SecurityCodeCVVView } from './Views/Payments/ConfirmPayment/SecurityCodeCVVView';
import { InstantCheckoutLeaveEnrollment } from './Views/Payments/InstantCheckoutLeaveEnrollment';
import { EditAddressView } from './Views/Addresses/EditAddressView/EditAddressView';
import { EditPaymentView } from './Views/Payments/EditPaymentView/EditPaymentView';
import {
  addAddresses,
  orangePayToken,
  updateInstantCheckoutSettings,
} from '../../models/graphQLModels';
import { AddAddressView } from './Views/Addresses/InstantCheckoutBillingDelivery/AddAddressView';

export const InstantCheckoutDrawerContent = () => {
  const { currentView } = useViews();
  const renderView = () => {
    switch (currentView) {
      case SELECT_DELIVERY_ADDRESS:
        return <SelectAddressView addressType="Delivery" />;

      case ADD_DELIVERY_ADDRESS:
        return (
          <QueryProvider cacheKey="instantCheckoutAddAddress">
            <AddAddressView addressType="delivery" />
          </QueryProvider>
        );

      case SELECT_PAYMENT:
        return <SelectPaymentView />;

      case ADD_PAYMENT:
        return (
          <QueryProvider cacheKey="instantCheckoutAddPayment">
            <InstantCheckoutAddPayment />
          </QueryProvider>
        );

      case CONFIRM_PAYMENT:
        return (
          <QueryProvider cacheKey="instantCheckoutConfirmPayment">
            <SecurityCodeCVVView />
          </QueryProvider>
        );

      case CONFIRM_LEAVE:
        return <InstantCheckoutLeaveEnrollment />;

      case EDIT_ADDRESS:
        return (
          <QueryProvider cacheKey="instantCheckoutEditAddress">
            <EditAddressView />
          </QueryProvider>
        );

      case EDIT_PAYMENT:
        return (
          <QueryProvider cacheKey="instantCheckoutEditPayment">
            <EditPaymentView />
          </QueryProvider>
        );

      default:
        return null;
    }
  };

  return renderView();
};

InstantCheckoutDrawerContent.dataModel = {
  updateInstantCheckoutSettings,
  orangePayToken,
  addAddresses,
};
